export const coverTypes = ["Option1", "Option2", "Option3", "Option4"];

export const planTypes = {
  MOTHER: "mother-covers",
  MASTER: "master-covers",
  CUSTOMIZE: "customize-covers",
};
